import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/anvil/casts']['POST'];
type Input = ThisApi['body'];

const createAnvilCast = async ({ fileBase64, fileName, title, creatorId }: Input): Promise<ThisApi['response']> => {
  const data = await noodleApiClient.post('/anvil/casts', {
    creatorId,
    fileBase64,
    fileName,
    title,
  });
  return data.data;
};

export default createAnvilCast;
